































































































































































































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import sitesApi from '@/api/sites.api';
import { ISite } from '@/entities/sites/site.interface';
import { SiteStatus } from '@/entities/sites/site-status.enum';
import * as types from '@/store/types';
import {IConfirm} from '@/entities';
import { mapGetters } from 'vuex';
import store from '@/store/store';

const passwordDefaultValidator = 'confirmed:passwordConfirm';

@Component({
     computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class SitesEdit extends EditPage {
    public parentPath: string = '/app/sites';
    public loadEnableForAllOffices: boolean = false;

    public formState: IDictionary<IFormControl> = {
        shortname: {
            key: 'shortname',
            label: 'Short name',
            value: '',
            validators: 'required|max:16'
        },
        sitename: {
            key: 'sitename',
            label: `Site name`,
            value: '',
            validators: 'required|max:128'
        },
        abbr: {
            key: 'abbr',
            label: `Abbr`,
            value: '',
            validators: 'required|max:10'
        },
        useApproveSale : {
            key: 'useApproveSale',
            label: 'Use CardApprove, Sale',
            value: false
        },
        clickParam: {
            key: 'clickParam',
            label: 'Click parameter name',
            value: '',
            validators: 'max:16'
        },
        url: {
            key: 'url',
            label: 'Url',
            value: '',
            validators: 'required|max:128'
        },
        contactName: {
            key: 'contactName',
            label: 'Contact Name',
            value: '',
            validators: 'max:64'
        },
        phoneNum: {
            key: 'phoneNum',
            label: 'Phone',
            value: '',
            validators: 'max:64'
        },
        type: {
            key: 'type',
            label: 'Type',
            value: '',
            validators: 'required'
        },
        // payout: {
        //     key: 'payout',
        //     label: 'Payout',
        //     value: ''
        // },
        note: {
            key: 'note',
            label: 'Notes',
            value: ''
        },
        status: {
            key: 'activated',
            label: 'Activated',
            value: SiteStatus.Suspended
        },
        specialReport: {
            key: 'specialReport',
            label: 'Use in special reports',
            value: false
        },
        email: {
            key: 'email',
            label: 'Email',
            value: '',
            validators: 'email|max:64'
        },
        avp: {
            key: 'avp',
            label: 'AVP',
            value: false
        },
    };

    public async created() {
        await super.created();
        if (this.isNew) {
            this.formState.status.value = SiteStatus.Activated;
        }
    }

    public detail(id: number): Promise<ISite> {
        return sitesApi.get(id);
    }

    public create(body: any): Promise<number> {
        return sitesApi.create(body);
    }

    public update(body: any): Promise<number> {
        return sitesApi.update(this.id, body);
    }

    public enableForAllOffices() {
        let afterFn = async (closeFn: () => void) => {
            this.loadEnableForAllOffices = true;
            await sitesApi.enableForAllOffices(this.id);
            closeFn();
            this.loadEnableForAllOffices = false;
        };
        let payload: IConfirm = {
            heading: 'Are you sure enable site for all offices?',
            afterFn
        };
        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    public deleteSite() {
        let afterFn = async (closeFn: () => void) => {
            try {
                await sitesApi.delete(this.id);
                this.$router.push(this.parentPath);
            } finally {
                closeFn();
            }
        };
        let payload: IConfirm = {
            heading: 'Are you sure you want delete site and all links?',
            afterFn
        };
        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }
}
